var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.9999C17.0751 21.9999 22 17.0751 22 11C22 4.92486 17.0751 0 11 0C4.92487 0 0 4.92486 0 11C0 17.0751 4.92487 21.9999 11 21.9999Z",
    fill: "#1977F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2818 14.1803L15.7691 10.9999H12.7186V8.93634C12.7186 8.06699 13.144 7.21774 14.5114 7.21774H15.899V4.51067C15.899 4.51067 14.6398 4.29565 13.4363 4.29565C10.9242 4.29565 9.28137 5.8178 9.28137 8.57592V10.9999H6.48767V14.1803H9.28137V21.8668C9.84135 21.955 10.4152 21.9999 11 21.9999C11.5847 21.9999 12.1586 21.9535 12.7186 21.8668V14.1803H15.2818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ccbe29cacfca51718612c2f5e7972117.svg";
export { ForwardRef as ReactComponent };